export enum ModelElementType {
  Left = 'L',
  Central = 'C',
  Right = 'R'
}
